import {
    Application,
    ApplicationCategory,
    ApplicationStatus,
} from '../types';

// FNP-79: form-only flag that gates the programmatic-provisioning fields.
// Stripped from the payload before submit so the GraphQL input shape stays
// clean. When true, applicationStatus is forced to CREATING regardless of
// the radio selection — the state machine drives the lifecycle from there.
export type FormValues = Application & {
    provisionAutomatically?: boolean,
};

// FNP-279 made applicationCategory required and FNP-47 made applicationStatus
// required, but records created earlier (or via the API / programmatic
// provisioning without picking a category) arrive with these fields empty. On
// edit that made the whole schema fail on submit — even a name-only change was
// blocked, with the error hidden below the fold. Default the missing values so
// the edit goes through and the gap is backfilled on save. Only genuinely empty
// values are filled, so a live status like CREATING/FAILED is never clobbered.
export const buildInitialValues = (record?: Application): FormValues => {
    const initialValues = {provisionAutomatically: false} as FormValues;

    if (!record) {
        return initialValues;
    }

    return {
        ...initialValues,
        ...record,
        applicationCategory: record.applicationCategory || ApplicationCategory.BUSINESS,
        applicationStatus: record.applicationStatus || ApplicationStatus.ACTIVE,
    };
};
